import { createClient } from '@supabase/supabase-js'

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL?.trim()
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY?.trim()

const PLACEHOLDER_URL = 'your-project-ref.supabase.co'
const PLACEHOLDER_KEY = 'your-anon-key'

function isRealSupabaseConfig(url, key) {
  if (!url || !key) return false
  if (url.includes(PLACEHOLDER_URL) || key === PLACEHOLDER_KEY) return false
  if (!url.startsWith('https://') || !url.endsWith('.supabase.co')) return false
  if (key.length < 40) return false
  return true
}

export const isSupabaseConfigured = isRealSupabaseConfig(supabaseUrl, supabaseAnonKey)

if (!isSupabaseConfigured && import.meta.env.DEV) {
  console.warn(
    '[JUNTAS] Variables VITE_SUPABASE_URL et VITE_SUPABASE_ANON_KEY manquantes. Copiez env.example vers .env.',
  )
}

export const supabase = isSupabaseConfigured
  ? createClient(supabaseUrl, supabaseAnonKey, {
      auth: {
        autoRefreshToken: true,
        persistSession: true,
        detectSessionInUrl: true,
      },
    })
  : null
